// client/src/context/initialStates/knowledgeInitialState.js

const knowledgeInitialState = {
  knowledgePosts: [],
  newKnowledgeCount: 0,
  newKnowledgeFileNames: [],
  isKnowledgeLoaded: false,
  knowledgePostsCount: 0,
  error: null,
};

export default knowledgeInitialState;